import React, { useState } from "react";
import { PropertyToEdit } from "redux/reducers/Properties/PropertiesSliceTypes";
import { FileText, ChevronDown, ChevronUp } from "lucide-react";
import { getDescriptionParts } from "utils/renderDescription";

interface PropertyDescriptionProps {
  propertyData: PropertyToEdit | null;
}

const PropertyDescription: React.FC<PropertyDescriptionProps> = ({
  propertyData,
}) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  if (!propertyData) return null;

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription);
  };

  //const description = propertyData?.description || "";
  const { html, content, plainLength } = getDescriptionParts(propertyData?.description);
  const shouldTruncate = plainLength > 320;

  return (
    <div className="listingSection__wrap w-full">
      {/* Header Section */}
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-xl">
            <FileText size={24} className="text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
              About this place
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
              What makes this property special
            </p>
          </div>
        </div>
      </div>

      <div className="w-full h-px bg-gradient-to-r from-transparent via-neutral-300 dark:via-neutral-700 to-transparent my-6" />

      {/* Description Content */}
      <div className="relative">
        <div
          className={`prose prose-sm sm:prose-base dark:prose-invert max-w-none transition-all duration-300 ${
            !showFullDescription && shouldTruncate ? "max-h-32 overflow-hidden" : ""
          }`}
        >
          {html ? (
  <div
    className="text-gray-700 dark:text-gray-300 leading-relaxed"
    dangerouslySetInnerHTML={{ __html: content }}
  />
) : (
  <div className="text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-line">
    {content}
  </div>
)}
        </div>

        {/* Gradient Overlay for Truncated Text */}
        {!showFullDescription && shouldTruncate && (
          <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white dark:from-neutral-900 to-transparent pointer-events-none" />
        )}
      </div>

      {/* Show More/Less Button */}
      {shouldTruncate && (
        <div className="mt-6 flex justify-center">
          <button
            onClick={toggleDescription}
            className="inline-flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-neutral-600 rounded-xl hover:bg-gray-50 dark:hover:bg-neutral-700 hover:border-[#f5694b] dark:hover:border-[#f5694b] hover:text-[#f5694b] transition-all shadow-sm hover:shadow-md"
          >
            {showFullDescription ? (
              <>
                Show less
                <ChevronUp size={16} />
              </>
            ) : (
              <>
                Show more
                <ChevronDown size={16} />
              </>
            )}
          </button>
        </div>
      )}

      {/* Additional Info Banner */}
      {/*description && (
        <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-200 dark:border-blue-800">
          <p className="text-sm text-blue-900 dark:text-blue-100">
            <span className="font-semibold">Looking for more details?</span> Contact the owner 
            to learn more about the property, neighborhood, and what makes this place unique.
          </p>
        </div>
      )*/}
    </div>
  );
};

export default PropertyDescription;